import { extend } from 'flarum/common/extend';
import VerifiedBadge from '../common/components/VerifiedBadge';

/**
 * Sem `plain` mesmo dentro do hover card: o popover segue só a configuração
 * `show_tooltip`, igual às demais superfícies.
 */
export default function addBadgeToUserCard() {
  extend('flarum/forum/components/UserCard', 'contentItems', function (items) {
    const user = this.attrs.user;
    if (!user || !user.isVerified || !user.isVerified()) return;
    if (!items.has('identity')) return;
    const identityItem = items.get('identity');
    if (!identityItem) return;
    const badge = m(VerifiedBadge, {
      user: user,
      className: "VerifiedBadge--card"
    });
    items.setContent('identity', m("h1", {
      className: identityItem.attrs && identityItem.attrs.className || 'UserCard-identity'
    }, identityItem.children, " ", badge));
  });
}